import './Axis.css';
export var axis = '_90oaxp0-3-5-0';